import { Component } from '@opten/compiler/metadata/component';
import { MapSearcher } from './map-searcher';

@Component({ className: 'js-shopfinder' })
export class Shopfinder {
	constructor(private element: HTMLElement) {
		const mapSearcher = new MapSearcher(this.element, {
			mapStyles: [
				{
					featureType: 'administrative.land_parcel',
					stylers: [
						{
							visibility: 'off',
						},
					],
				},
				{
					featureType: 'administrative.neighborhood',
					stylers: [
						{
							visibility: 'off',
						},
					],
				},
				{
					featureType: 'landscape',
					elementType: 'geometry.fill',
					stylers: [
						{
							visibility: 'on',
						},
					],
				},
				{
					featureType: 'landscape',
					elementType: 'labels.icon',
					stylers: [
						{
							visibility: 'off',
						},
					],
				},
				{
					featureType: 'poi',
					elementType: 'labels.text',
					stylers: [
						{
							visibility: 'off',
						},
					],
				},
				{
					featureType: 'poi.business',
					stylers: [
						{
							visibility: 'off',
						},
					],
				},
				{
					featureType: 'road',
					elementType: 'geometry.fill',
					stylers: [
						{
							color: '#ffffff',
						},
					],
				},
				{
					featureType: 'road',
					elementType: 'geometry.stroke',
					stylers: [
						{
							color: '#ffffff',
						},
					],
				},
				{
					featureType: 'road',
					elementType: 'labels',
					stylers: [
						{
							visibility: 'off',
						},
					],
				},
				{
					featureType: 'road',
					elementType: 'labels.icon',
					stylers: [
						{
							visibility: 'off',
						},
					],
				},
				{
					featureType: 'road.arterial',
					stylers: [
						{
							visibility: 'off',
						},
					],
				},
				{
					featureType: 'road.highway',
					elementType: 'labels',
					stylers: [
						{
							visibility: 'simplified',
						},
					],
				},
				{
					featureType: 'road.local',
					stylers: [
						{
							visibility: 'off',
						},
					],
				},
				{
					featureType: 'transit',
					stylers: [
						{
							visibility: 'off',
						},
					],
				},
				{
					featureType: 'water',
					elementType: 'labels.text',
					stylers: [
						{
							visibility: 'off',
						},
					],
				},
			],
		});
	}
}
